import React from 'react';

import ReviewBox from './ReviewBox/ReviewBox';

import classes from './HomeReviewes.module.scss';

interface Props {
  className?: string;
}

const HomeReviewesView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={`${classes['container']} ${props.className}`}>
      <h3 className={classes['title']}>Trusted by 1,000,000 customers</h3>
      <ul className={classes['list']}>
        <li>
          <ReviewBox></ReviewBox>
        </li>
        <li>
          <ReviewBox></ReviewBox>
        </li>
        <li>
          <ReviewBox></ReviewBox>
        </li>
        <li>
          <ReviewBox></ReviewBox>
        </li>
      </ul>
    </div>
  );
};

HomeReviewesView.displayName = 'HomeReviewesView';
HomeReviewesView.defaultProps = {};

export default HomeReviewesView;
